<template>
  <!-- SLIDER-->
  <div class="container mb-30">
    <div id="carousel-slider" data-ride="carousel" class="carousel slide">
      <!-- Indicators-->
      <ol class="carousel-indicators">
        <li data-target="#carousel-slider" v-for="(project, index) in projects" :data-slide-to="index" :class="active(project)"></li>
      </ol>
      <!-- Wrapper for slides-->
      <div role="listbox" class="carousel-inner">
        <slide v-for="project in projects" :key="project.id" :project="project" :active="active(project)"></slide>
      </div>
    </div>
  </div>
</template>

<script>
import Slide from '@/components/Project/Slider/Slide';

export default {
  props: ['projects'],
  components: { Slide },
  methods: {
    active(project) {
      return project === this.projects[0] ? 'active' : '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?30221dea